<template>
  <div v-if="!isSubmitted" class="card-body">
    <div class="icon-section">
      <div class="icon-bg">
        <img src="../public/images/icon-star.svg" alt="rate us">
      </div>
    </div>
    <div class="text-section">
      <h1>How did we do?</h1>
      <p>Please let us know how we did with your support request. All feedback is appreciated
        to help us improve our offering!</p>
    </div>
    <div class="form-section">
      <form @submit.prevent="formSubmit">
          <button v-for="(button, index) in buttons" :key="index" @click="selectBtn(index)" :class="[{ rateBtnClicked: button.isClicked }, 'rateBtn']" type="button">{{ button.value }}</button>
        <button class="submit-btn" type="submit">Submit</button>
      </form>
    </div>
  </div>

  <div v-else class="card-body">
    <div class="thank-you-pic">
      <img src="../public/images/illustration-thank-you.svg" alt="">
    </div>
    <div class="thank-you-rating">
      <span>You selected {{ ratingValue }} out of 5</span>
    </div>
    <div class="thank-you-thanks">
      <h1>Thank You!</h1>
      <p>We appreciate you taking the time to give a rating. If you ever need more support, 
  don’t hesitate to get in touch!</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      buttons: [{value:1, isClicked: false},{value:2, isClicked: false},{value:3, isClicked: false},{value:4, isClicked: false},{value:5, isClicked: false}],
      ratingValue: 0,
      isSubmitted: false
    }
  },
  methods: {
    formSubmit() {
      this.isSubmitted = true
    },
    selectBtn(id){
      id++
      for(let i = 0; i < this.buttons.length; i++){
        if(id == this.buttons[i].value){
          this.buttons[i].isClicked = true
          this.ratingValue = this.buttons[i].value
        } else {
          this.buttons[i].isClicked = false
        }
      }
      
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Overpass:wght@400;700&display=swap');

:root {
  --orange: hsl(25, 97%, 53%);
  --white: hsl(0, 0%, 100%);
  --light-grey: hsl(217, 12%, 63%);
  --medium-grey: hsl(216, 12%, 54%);
  --dark-blue: hsl(213, 19%, 18%);
  --very-dark-blue: hsl(216, 12%, 8%);
}

* {
  font-size: 15px;
}

body {
  background-color: var(--very-dark-blue);
}

.card-body {
  font-family: 'Overpass', sans-serif;
  display: grid;
  grid-template-rows: 0fr 0fr 0fr;
  width: 350px;
  height: 370px;
  background-color: var(--dark-blue);
  background-image: linear-gradient(to bottom left, var(--dark-blue),hsl(215, 27%, 12%));
  border-radius: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.icon-section {
  border-radius: 20px 20px 0px 0px;
  padding: 20px;
  padding-bottom: 10px;
}

.icon-bg {
  width: 45px;
  height: 45px;
  background-color: hsl(216, 12%, 54%, 10%);
  border-radius: 50%;
  text-align: center;
}

.icon-bg img {
  width: 18px;
  margin-top: 29%;
}

.text-section {
  padding: 20px;
}

.text-section h1 {
  color: var(--white);
  font-weight: 700;
  font-size: 1.8rem;
  margin-bottom: 10px;
}

.text-section p {
  color: var(--light-grey);
  font-weight: 400;
  line-height: 1.3;
}

.form-section {
  /* background-color: var(--dark-blue); */
  border-radius: 0px 0px 20px 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  text-align: center;
}

.rateBtn {
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 50%;
  background-color: hsl(216, 12%, 54%, 10%);
  color: var(--light-grey);
  display: inline-block;
  cursor: pointer;
  transition: 0.3s;
  margin-right: 17px;
  margin-bottom: 20px;
  font-weight: 700;
}

.rateBtn:hover {
  background: var(--orange);
  color: var(--white);
}

.rateBtnClicked {
  background-color: var(--medium-grey);
  color: var(--white);
}

.submit-btn {
  background: var(--orange);
  border: none;
  color: var(--white);
  font-family: 'Overpass', sans-serif;
  width: 100%;
  padding: 10px;
  font-weight: 400;
  letter-spacing: 2px;
  text-transform: uppercase;
  border-radius: 30px;
  transition: 0.3s;
}

.submit-btn:hover {
  background-color: var(--white);
  color: var(--orange);
}

.thank-you-pic {
  text-align: center;
  padding-top: 30px;
}

.thank-you-rating {
  text-align: center;
  padding-top: 30px;
}

.thank-you-rating span{
  background: hsl(216, 12%, 54%, 10%);
  width:fit-content;
  padding: 10px 12px;
  color: var(--orange);
  border-radius: 30px;
  vertical-align: middle;
}

.thank-you-thanks {
  text-align: center;
  padding-top: 40px;
}

.thank-you-thanks h1{
  color: var(--white);
  font-weight: 700;
  font-size: 1.8rem;
  margin-bottom: 10px;
}

.thank-you-thanks p {
  color: var(--light-grey);
  font-weight: 400;
  line-height: 1.3;
}
</style>
